// db-filter.js

const REVIEW_BUCKET_ORDER = ["4.5★+", "4★+", "3.5★+", "3★+", "<3★", "No reviews"];
// Buckets (display order) + matching rules (used when filtering)
const REVIEW_RULES = [
  { label: "4.5★+",  test: ({avg, count}) => count > 0 && avg >= 4.5 },
  { label: "4★+",    test: ({avg, count}) => count > 0 && avg >= 4.0 },
  { label: "3.5★+",  test: ({avg, count}) => count > 0 && avg >= 3.5 },
  { label: "3★+",    test: ({avg, count}) => count > 0 && avg >= 3.0 },
  { label: "<3★",    test: ({avg, count}) => count > 0 && avg <  3.0 },
  { label: "No reviews", test: ({avg, count}) => count === 0 }
];

function getReviewInfoFromCell(cell) {
  const wrap = cell?.querySelector?.('.td-wrapper');
  if (!wrap) return { avg: 0, count: 0 };
  // If hydrator ran, dataset.value is reliable
  const avg = parseFloat(wrap.dataset.value || "") || 0;
  // Extract count from text (keeps this independent of extra attrs)
  const m = (wrap.textContent || "").match(/\((\d+)\)/);
  const count = m ? parseInt(m[1], 10) : 0;
  return { avg, count };
}

function getReviewBucketFromCell(cell) {
  const info = getReviewInfoFromCell(cell);
  const found = REVIEW_RULES.find(rule => rule.test(info));
  return found ? found.label : "No reviews";
}

function showDropdownMenu(column, values) {
  // 🔥 Fix: normalize column to always be a string
  if (column instanceof HTMLElement) {
    column = column.dataset.column || column.textContent.trim();
  }
  column = String(column);

  console.log("showDropdownMenu called for:", column);
  const idSafe = column.replace(/\s+/g, "-").replace(/[()]/g, "");

  if (column === "Stock") {
    values = ["In Stock", "Out of Stock"];
  }

  const container = document.getElementById("dropdown-menu-container");

  const activeFilterSpan = document.querySelector(
    `.selected-filter[data-column="${column}"]`
  );
  const activeValues =
    activeFilterSpan?.textContent
      .split(",")
      .map((v) => v.trim().toLowerCase())
      .filter(Boolean) || [];

  const searchEnabled = ["Brand", "Name", "Compatibility"].includes(column);

// ── Date range picker for “Date Added” ───────────────────────────
if (column === "Date Added") {
  const idSafe = column.replace(/\s+/g, "-").replace(/[()]/g, "");

  // collect all valid row dates
  const allDates = Array.from(
    document.querySelectorAll("table tbody tr[data-created]")
  )
    .map(r => new Date(r.dataset.created))
    .filter(d => !isNaN(d));
  if (allDates.length === 0) {
    console.warn("No valid creation dates found for Date Added filter");
    return;
  }

  const minDate = new Date(Math.min(...allDates));
  const maxDate = new Date(Math.max(...allDates));

  // parse current filter span “YYYY-MM-DD→YYYY-MM-DD” from activeFilterSpan
  let [currMin, currMax] = activeFilterSpan?.textContent.split("→") || [];
  currMin = currMin || minDate.toISOString().slice(0, 10);
  currMax = currMax || maxDate.toISOString().slice(0, 10);

  container.innerHTML = `
    <div style="display:flex; gap:8px; justify-content:center; margin-bottom:12px;">
      <input type="date" id="date-min-${idSafe}" value="${currMin}" min="${minDate.toISOString().slice(0,10)}" max="${maxDate.toISOString().slice(0,10)}">
      <span>to</span>
      <input type="date" id="date-max-${idSafe}" value="${currMax}" min="${minDate.toISOString().slice(0,10)}" max="${maxDate.toISOString().slice(0,10)}">
    </div>
    <div class="dropdown-footer">
      <button id="clear-date-${idSafe}" class="padded margin-box-1">
        Clear
      </button>
    </div>
  `;

  container.style.display = "flex";

  const minInput = container.querySelector(`#date-min-${idSafe}`);
  const maxInput = container.querySelector(`#date-max-${idSafe}`);
  const clearBtn = container.querySelector(`#clear-date-${idSafe}`);

  function applyDateFilter() {
    const vMin = minInput.value;
    const vMax = maxInput.value;
    activeFilterSpan.textContent = vMin && vMax ? `${vMin}→${vMax}` : "";
    updateDropdownClearButtonVisibility(column);
    updateFilterButtonsVisibility();
    updateURLFromFilters();
    applyColumnFilters();
  }

  minInput.addEventListener("change", applyDateFilter);
  maxInput.addEventListener("change", applyDateFilter);
  clearBtn.addEventListener("click", () => {
    minInput.value = minDate.toISOString().slice(0,10);
    maxInput.value = maxDate.toISOString().slice(0,10);
    activeFilterSpan.textContent = "";
    updateDropdownClearButtonVisibility(column);
    updateFilterButtonsVisibility();
    updateURLFromFilters();
    applyColumnFilters();
  });
  return;
}

if (["Price", "Length (mm)", "Width (mm)", "Height (mm)", "Area (cm²)"].includes(column)) {
    const columnIndexMap = {};
    document.querySelectorAll("thead th").forEach((th, index) => {
      const label = th.querySelector(".dropdown-toggle")?.dataset.column;
      if (label) columnIndexMap[label] = index;
    });
    const colIndex = columnIndexMap[column];
    const allRows = Array.from(document.querySelectorAll("table tbody tr"));
    const columnValues = allRows
      .map((row) => {
        const cell = row.children[colIndex];
        const text = cell?.textContent.replace(/[^\d.]/g, "");
        const num = parseFloat(text);
        return isNaN(num) ? null : num;
      })
      .filter((v) => v !== null);
    const minVal = Math.min(...columnValues);
    const maxVal = Math.max(...columnValues);

    const filterSpan = document.querySelector(
      `.selected-filter[data-column="${column}"]`
    );
    let startMin = minVal,
      startMax = maxVal;
    if (filterSpan && filterSpan.textContent.trim()) {
      const parts = filterSpan.textContent.split("-").map((s) => s.trim());
      const parsedMin = parseFloat(parts[0].replace(/[^\d.]/g, ""));
      const parsedMax = parseFloat(parts[1].replace(/[^\d.]/g, ""));
      if (!isNaN(parsedMin) && !isNaN(parsedMax)) {
        startMin = parsedMin;
        startMax = parsedMax;
      }
    }

    container.innerHTML = `
      <div style="display: flex; gap: 10px; justify-content: center;">
        <input
          type="number"
          id="min-${column}"
          value="${startMin}"
          min="${minVal}"
          max="${maxVal}"
          style="width: 60px;"
        >
        <span>-</span>
        <input
          type="number"
          id="max-${column}"
          value="${startMax}"
          min="${minVal}"
          max="${maxVal}"
          style="width: 60px;"
        >
      </div>
      <div id="slider-container-${column}" style="margin: 12px 0;"></div>
      <div class="dropdown-footer">
        <button id="clear-range-${column}" class="padded margin-box-1">
          Clear
        </button>
      </div>
    `;

    container.style.display = "flex";

    const sliderContainer = document.getElementById(
      `slider-container-${column}`
    );
    noUiSlider.create(sliderContainer, {
      start: [startMin, startMax],
      connect: true,
      range: { min: minVal, max: maxVal },
      step: 1,
    });

    const minInput = document.getElementById(`min-${column}`);
    const maxInput = document.getElementById(`max-${column}`);
    const clearBtn = document.getElementById(`clear-range-${column}`);

    clearBtn.style.display =
      startMin !== minVal || startMax !== maxVal ? "inline-block" : "none";

    sliderContainer.noUiSlider.on("update", (values, handle) => {
      if (handle === 0) {
        minInput.value = values[0];
      } else {
        maxInput.value = values[1];
      }
    });

    sliderContainer.noUiSlider.on("set", () => {
      applyRangeFilter(column);
      const [currMin, currMax] = sliderContainer.noUiSlider
        .get()
        .map(parseFloat);
      clearBtn.style.display =
        currMin !== minVal || currMax !== maxVal ? "inline-block" : "none";
    });

    minInput.addEventListener("change", () => {
      sliderContainer.noUiSlider.set([minInput.value, null]);
    });
    maxInput.addEventListener("change", () => {
      sliderContainer.noUiSlider.set([null, maxInput.value]);
    });

    clearBtn.addEventListener("click", () => {
      minInput.value = minVal;
      maxInput.value = maxVal;
      sliderContainer.noUiSlider.set([minVal, maxVal]);

      if (filterSpan) filterSpan.textContent = "";
      clearBtn.style.display = "none";

      updateFilterButtonsVisibility();
      updateURLFromFilters();
      applyColumnFilters();
    });

    return;
  } else if (column.toLowerCase() === "colour") {
    container.innerHTML = `
    <div class="dropdown-content">
      <div class="dropdown-static-header">
        <label class="custom-style-1" style="font-weight:bold;">
          <input type="checkbox" id="dropdown-select-all" />
          Select All
        </label>
      </div>
      <div id="dropdown-values-container">
        ${values
          .map((v) => {
          const parts = v
            .split(/\s*•\s*|\s*,\s*|\s*\/\s*/)
            .map((val) => val.trim())
            .filter(Boolean);
          
          const cssParts = parts.map(
            (label) =>
              window.DB_COLOUR_MAP[label] ||
              label.replace(/\s+/g, "").toLowerCase()
          );
          
          const swatchHtml = cssParts
            .map(
              (color) =>
                `<div style="flex:1; background:${color};"></div>`
            )
            .join("");

            return `
              <label class="custom-style-1" style="display: flex; align-items: center;">
                <input
                  type="checkbox"
                  value="${v}"
                  data-column="${column}"
                  class="filter-checkbox"
                  ${activeValues.includes(v.toLowerCase()) ? "checked" : ""}
                >
                <div class="colour-block">
                  ${swatchHtml}
                </div>
                <span style="margin-left: 8px;">${v}</span>
              </label>
            `;
          })
          .join("")}
      </div>
    </div>
    <div class="dropdown-footer">
      <button id="clear-column-${idSafe}" class="padded margin-box-1">
        Clear
      </button>
    </div>
  `;

    rebindCheckboxEvents(column);
    
    const selectAll = container.querySelector("#dropdown-select-all");
      if (selectAll) {
        selectAll.addEventListener("change", (e) => {
          const boxes = container.querySelectorAll(".filter-checkbox");
          const allValues = [];
          boxes.forEach((cb) => {
            cb.checked = e.target.checked;
            allValues.push(cb.value);
          });
      
          const span = document.querySelector(
            `.selected-filter[data-column="${column}"]`
          );
          span.textContent = e.target.checked ? allValues.join(", ") : "";
      
          updateDropdownClearButtonVisibility(column);
          updateFilterButtonsVisibility();
          updateURLFromFilters();
          applyColumnFilters();
        });
      }

    updateDropdownClearButtonVisibility(column);

    const clearButton = container.querySelector(`#clear-column-${idSafe}`);
      if (clearButton) {
        clearButton.addEventListener("click", () => {
          const checkboxes = container.querySelectorAll(`.filter-checkbox[data-column="${column}"]`);
          checkboxes.forEach((cb) => {
            cb.checked = false;
            cb.removeAttribute("checked");
          });
      
          const span = document.querySelector(`.selected-filter[data-column="${column}"]`);
          if (span) span.textContent = "";
      
          const selectAll = container.querySelector("#dropdown-select-all");
          if (selectAll) selectAll.checked = false;
      
          updateDropdownClearButtonVisibility(column);
          updateFilterButtonsVisibility();
          updateURLFromFilters();
          applyColumnFilters();
        });
      }

    container.style.display = "flex";
    return;
  } else {
    container.innerHTML = `
      ${
        searchEnabled
          ? `<input type="text" id="dropdown-filter-search" placeholder="Search..." class="padded-5">`
          : ""
      }
      <div class="dropdown-content">
          <!-- Select All control -->
          
          ${
            values.length > 4
              ? `
              <div class="dropdown-static-header">
                <label class="custom-style-1" style="font-weight:bold;">
                  <input type="checkbox" id="dropdown-select-all" />
                  Select All
                </label>
              </div>`
              : ""
              }
          
        <div id="dropdown-values-container">
          ${values
            .map((v) => {
              const dv = column === "Brand" ? getDisplayVendor(v) : v;
              const checked = activeValues.includes(dv.toLowerCase())
                ? "checked"
                : "";
              return `
                <label class="custom-style-1">
                  <input
                    type="checkbox"
                    value="${dv}"
                    data-column="${column}"
                    class="filter-checkbox"
                    ${checked}
                  >
                  ${dv}
                </label>
              `;
            })
            .join("")}
        </div>
      </div>
      <div class="dropdown-footer">
        <button id="clear-column-${idSafe}" class="padded margin-box-1">
          Clear
        </button>
      </div>
    `;

    const selectAll = container.querySelector("#dropdown-select-all");
    if (selectAll) {
      selectAll.addEventListener("change", (e) => {
        const boxes = container.querySelectorAll(".filter-checkbox");
        const allValues = [];
        boxes.forEach((cb) => {
          cb.checked = e.target.checked;
          allValues.push(cb.value);
        });

        const span = document.querySelector(
          `.selected-filter[data-column="${column}"]`
        );
        span.textContent = e.target.checked ? allValues.join(", ") : "";

        updateDropdownClearButtonVisibility(column);
        updateFilterButtonsVisibility();
        updateURLFromFilters();
        applyColumnFilters();
      });
    }

    container.style.display = "flex";
    const searchInput = container.querySelector("#dropdown-filter-search");
    const valuesList = container.querySelector("#dropdown-values-container");
    if (searchEnabled && searchInput) {
      searchInput.addEventListener("input", () => {
        const term = searchInput.value.toLowerCase();
        valuesList.innerHTML = values
          .filter((v) => v.toLowerCase().includes(term))
          .map((v) => {
            const dv = column === "Brand" ? getDisplayVendor(v) : v;
            const isCh = activeValues.includes(dv.toLowerCase());
            return `
              <label class="custom-style-1">
                <input
                  type="checkbox"
                  value="${dv}"
                  data-column="${column}"
                  class="filter-checkbox"
                  ${isCh ? "checked" : ""}
                >
                ${dv}
              </label>
            `;
          })
          .join("");
        rebindCheckboxEvents(column);
      });
    }

    rebindCheckboxEvents(column);
    updateDropdownClearButtonVisibility(column);

    const clearButton = container.querySelector(`#clear-column-${idSafe}`);
    if (clearButton) {
      clearButton.addEventListener("click", () => {
        if (selectAll) selectAll.checked = false;

        container
          .querySelectorAll(`.filter-checkbox[data-column="${column}"]`)
          .forEach((cb) => {
            cb.checked = false;
            cb.removeAttribute("checked");
          });

        const searchInput = container.querySelector(".filter-search-input");
        if (searchInput) searchInput.value = "";
        container.querySelectorAll(".filter-option").forEach((opt) => {
          opt.style.display = "";
        });

        const span = document.querySelector(
          `.selected-filter[data-column="${column}"]`
        );
        if (span) span.textContent = "";

        updateFilterButtonsVisibility();
        updateURLFromFilters();
        applyColumnFilters();
      });
    }

    return;
  }
}

function updateRowVisibility() {
  const filters = Array.from(document.querySelectorAll(".selected-filter"));
  const rows = document.querySelectorAll("table tbody tr");

  const columnIndexMap = {};
  document.querySelectorAll("thead th").forEach((th, index) => {
    const label = th.querySelector(".dropdown-toggle")?.dataset.column;
    if (label) columnIndexMap[label] = index;
  });

  rows.forEach((row) => {
    let visible = true;

    filters.forEach((filter) => {
      const column = filter.dataset.column;
      const colIndex = columnIndexMap[column];
      if (colIndex === undefined) return;

      const cell = row.children[colIndex];
      if (!cell) return;

      const selected = filter.textContent
        .toLowerCase()
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);

      if (selected.length === 0) return;

      // ── handle Date Added range ──────────────────────────────
        if (column === "Date Added") {
          const [minStr, maxStr] = filter.textContent.split("→");
          if (!minStr || !maxStr) {
            return; // nothing selected
          }

          // normalize everything to YYYY-MM-DD in UK time
          const toUkDay = (d) =>
            d.toLocaleDateString("en-CA", { timeZone: "Europe/London" }); // en-CA gives YYYY-MM-DD

          const minDay = toUkDay(new Date(minStr));
          const maxDay = toUkDay(new Date(maxStr));
          const rowDay = toUkDay(new Date(row.dataset.created));

          if (rowDay < minDay || rowDay > maxDay) {
            visible = false;
          }
          return;
        }
      if (
  ["Price", "Length (mm)", "Width (mm)", "Height (mm)", "Area (cm²)"].includes(column)
      ) {
        const [min, max] = filter.textContent
          .split("-")
          .map((v) => parseFloat(v));
        const cellVal =
          parseFloat(cell?.textContent.replace(/[^\d.]/g, "")) || 0;
        if ((!isNaN(min) && cellVal < min) || (!isNaN(max) && cellVal > max)) {
          visible = false;
        }
      } else if (column === "Stock") {
        const productId = row.getAttribute("data-product-id");
        const product = productMap[productId];
        const available = product?.variants?.edges[0]?.node?.availableForSale;

        const stockStatus = available ? "in stock" : "out of stock";

        const match = selected.some((v) => v.toLowerCase() === stockStatus);

        if (selected.length && !match) {
          visible = false;
        }
      } else if (column.toLowerCase() === "colour") {
        const productId = row.getAttribute("data-product-id");
        const product = productMap[productId];
        const colorTag = product?.tags.find((tag) =>
          tag.startsWith("Colour__")
        );
        const cleanColor = colorTag
          ? colorTag.replace("Colour__", "").trim().toLowerCase()
          : "";

        const match = selected.includes(cleanColor);
        if (!match) {
          visible = false;
        }
        } else if (column === "Game Type") {
          const parts = cell.textContent
            .split(/\s*[·•]\s*/)
            .map((s) => s.trim().toLowerCase())
            .filter(Boolean);

          const match = selected.some((v) => parts.includes(v.toLowerCase()));
          if (selected.length && !match) {
            visible = false;
          }

        } else if (column === "Reviews") {
          const info = getReviewInfoFromCell(cell);

          // selected is already lowercased; match by rule label lowercased
          const match = selected.some(sel => {
            const rule = REVIEW_RULES.find(r => r.label.toLowerCase() === sel);
            return rule ? rule.test(info) : false;
          });

          if (!match) visible = false;

        } else {
          // generic exact-match branch (Brand normalization kept)
          let cellText = (cell?.textContent || "").trim();
          if (column === "Brand") cellText = getDisplayVendor(cellText);
          const match = selected.some(
            (v) => v.toLowerCase() === cellText.toLowerCase()
          );
          if (selected.length && !match) visible = false;
      }
    });

    row.style.display = visible ? "" : "none";
  });
  // ── now that row visibility is final, update the badge ──
  refreshProductCounter();
}

function applyRangeFilter(column) {
  const min = parseFloat(document.getElementById(`min-${column}`).value);
  const max = parseFloat(document.getElementById(`max-${column}`).value);
  const span = document.querySelector(
    `.selected-filter[data-column="${column}"]`
  );

  if (!isNaN(min) || !isNaN(max)) {
    span.textContent = `${isNaN(min) ? "" : min}-${isNaN(max) ? "" : max}`;
  } else {
    span.textContent = "";
  }

  applyColumnFilters();

  updateDropdownClearButtonVisibility(column);
}

function rebindCheckboxEvents(column) {
  const container = document.getElementById("dropdown-menu-container");

  container.querySelectorAll(".filter-checkbox").forEach((cb) => {
    cb.addEventListener("change", () => {
      const colAttr = cb.getAttribute("data-column");
      const checked = Array.from(
        container.querySelectorAll(
          `.filter-checkbox[data-column="${colAttr}"]:checked`
        )
      ).map((cb) => cb.value);

      const filterSpan = document.querySelector(
        `.selected-filter[data-column="${colAttr}"]`
      );
      if (filterSpan) {
        filterSpan.textContent = checked.join(", ");
      }

      updateDropdownClearButtonVisibility(colAttr);
      updateFilterButtonsVisibility();
      if (!window._deepLinking) updateURLFromFilters();
      applyColumnFilters();

      const checkboxes = container.querySelectorAll(`.filter-checkbox[data-column="${colAttr}"]`);
      const selectAll = container.querySelector("#dropdown-select-all");
      
      if (selectAll) {
        const allChecked = Array.from(checkboxes).every((chk) => chk.checked);
        selectAll.checked = allChecked;
      }
    });
  });
}

function highlightFilteredColumns() {
  document.querySelectorAll(".selected-filter").forEach((filterSpan) => {
    const column = filterSpan.dataset.column;
    const flex = document
      .querySelector(`th .dropdown-toggle[data-column="${column}"]`)
      ?.closest(".flex-container-1");

    if (filterSpan.textContent.trim()) {
      flex?.classList.add("filter-active");
    } else {
      flex?.classList.remove("filter-active");
    }
  });
}

function applyColumnFilters() {
  updateRowVisibility();
  updateFilterButtonsVisibility();
  updateCompareButtonsVisibility();
  if (!window._deepLinking) updateURLFromFilters();
  highlightFilteredColumns();

  document.querySelectorAll(".selected-filter").forEach((span) => {
    const column = span.dataset.column;
    const values = span.textContent
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    const checkboxes = document.querySelectorAll(
      `.sidebar-filter-checkbox[data-column="${column}"]`
    );

    checkboxes.forEach((cb) => {
      cb.checked = values.includes(cb.value);
      updateCheckboxClearButtonVisibility(column);
      updateDropdownClearButtonVisibility(column);
    });
  });
  updateGroupClearButtonVisibility();
  updateFilterButtonsVisibility();
}

function updateDropdownClearButtonVisibility(column) {
  const idSafe = column.replace(/\s+/g, "-").replace(/[()]/g, "");
  const clearButton = document.getElementById(`clear-column-${idSafe}`);
  if (!clearButton) return;

  const anyChecked =
    document.querySelectorAll(
      `.filter-checkbox[data-column="${column}"]:checked`
    ).length > 0;

  clearButton.style.display = anyChecked ? "inline-block" : "none";
}

function getUniqueValuesForColumn(columnName) {
  const rows = document.querySelectorAll("tbody tr");
  const values = new Set();
  const ths = document.querySelectorAll("thead th");

  const columnIndex = Array.from(ths).findIndex((th) => {
    const btn = th.querySelector(".dropdown-toggle");
    return (btn?.dataset.column === columnName || th.textContent.trim() === columnName);
  });
  if (columnIndex === -1) return [];

  rows.forEach((row) => {
    const cell = row.children[columnIndex];
    if (!cell) return;
    const wrapper = cell.querySelector(".td-wrapper");
    if (columnName === "Reviews") {
      const avg = parseFloat(wrapper?.dataset.value || "0") || 0;
      const count = parseInt(wrapper?.dataset.count || "0", 10) || 0;
      const bucket = wrapper?.dataset.filter || (
        !count ? "No reviews" :
        avg >= 4.5 ? "4.5★+" :
        avg >= 4.0 ? "4★+" :
        avg >= 3.5 ? "3.5★+" :
        avg >= 3.0 ? "3★+" : "<3★"
      );
      if (bucket) values.add(bucket);
    } else {
      const text = wrapper ? (wrapper.dataset.value || wrapper.textContent).trim()
                           : cell.textContent.trim();
      if (text) values.add(text);
    }
  });

  return Array.from(values).filter(Boolean);
}

function setupDropdownFilters(tableElement) {
  tableElement.querySelectorAll(".dropdown-toggle").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.stopPropagation();
      const column = button.dataset.column;
     
      if (activeDropdownColumn === column) {
        const menu = document.getElementById("dropdown-menu-container");
        menu.style.display = "none";
        activeDropdownColumn = null;
        return;
      }

      const colIndex = [...button.closest("tr").children].indexOf(
        button.closest("th")
      );
      const rows = tableElement.querySelectorAll("tbody tr");
      const values = new Set();

      rows.forEach((row) => {
        if (row.style.display !== "none") {
        const productId = row.getAttribute("data-product-id");
        // Fallback: use numeric tail if full ID not in productMap
        let product = productMap[productId];
        if (!product) {
          const numericId = String(productId || "").match(/\d+$/)?.[0];
          product = numericId ? productMap[numericId] : null;
        }
        const cell = row.children[colIndex];
        if (!cell) return;

        if (column === "Reviews") {
          // Bucketise Reviews for the dropdown
          values.add(getReviewBucketFromCell(cell));
        } else if (column === "Game Type") {
            cell.textContent
              .split(/\s*[·•]\s*/)
              .map((s) => s.trim())
              .filter(Boolean)
              .forEach((type) => values.add(type));
          } else if (column === "Colour") {
            const colorTag = product.tags.find((tag) =>
              tag.startsWith("Colour__")
            );
            if (colorTag) {
              values.add(colorTag.replace("Colour__", "").trim());
            }
          } else if (column === "Brand") {
            let text = cell.textContent.trim();
            values.add(getDisplayVendor(text));
          } else {
            values.add(cell.textContent.trim());
          }
        }
      });

    activeDropdownColumn = column;
    
    const sorted = Array.from(values).sort((a, b) => {
      if (column === "Reviews") {
        const ai = REVIEW_BUCKET_ORDER.indexOf(a);
        const bi = REVIEW_BUCKET_ORDER.indexOf(b);
        return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      }
      if (column === "Static Friction" || column === "Dynamic Friction") {
        const order = ["Very Low", "Low", "Moderately Low", "Moderate", "Moderately High", "High", "Very High"];
        const ai = order.indexOf(a);
        const bi = order.indexOf(b);
        return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      }

     if (column === "Firmness") {
        const order = ["Extra Soft", "Soft", "Mid", "Hard"];
        const ai = order.indexOf(a);
        const bi = order.indexOf(b);
        return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      }

     if (column === "Texture") {
        const order = ["Ultra Smooth", "Smooth", "Slightly Textured", "Slightly Grainy", "Grainy", "Rough"];
        const ai = order.indexOf(a);
        const bi = order.indexOf(b);
        return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      }
    
      const numA = parseFloat(a);
      const numB = parseFloat(b);
      const isNumA = !isNaN(numA);
      const isNumB = !isNaN(numB);
      if (isNumA && isNumB) return numA - numB;
      if (isNumA) return -1;
      if (isNumB) return 1;
      return a.localeCompare(b);
    });
    
    showDropdownMenu(column, sorted);

      const th = button.closest("th");
      const rect = th.getBoundingClientRect();
      const menu = document.getElementById("dropdown-menu-container");

      const tableRect = tableElement.getBoundingClientRect();
      const menuWidth = menu.offsetWidth;

      let left = rect.left;

      if (left + menuWidth > tableRect.right) {
        left = rect.right - menuWidth;
        if (left < tableRect.left) {
          left = tableRect.left;
        }
      }

      menu.style.left = `${left}px`;
      menu.style.top = `${rect.bottom}px`;
    });
  });
}
